<template>
<div id="main-content" class="taskboard">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-sm-12">
          <h2><a href="javascript:void(0);" class="btn btn-xs btn-link btn-toggle-fullwidth"><i class="fa fa-arrow-left"></i></a> Tickets</h2>
          <ul class="breadcrumb">
            <li class="breadcrumb-item"><a href="index.html"><i class="icon-home"></i></a></li>                            
            <li class="breadcrumb-item">Apps</li>
            <li class="breadcrumb-item active">Tickets</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12">
        <div class="card">
          <div class="header">
            <h2>Ticket Detail</h2>
          </div>
            <div class="body">
              <div class="row">
                <div class="form-group col-3">
                  <label for="qbo-no">QBO No.</label>
                  <input type="text" class="form-control" v-model="td.cparNo" id="cpar-no" aria-describedby="code" disabled>
                </div>
                <div class="form-group col-3">
                  <label>Date</label>
                  <flat-pickr class="form-control" v-model="td.date" disabled></flat-pickr>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label for="qbo-no">Other Employee Name</label>
                  <input type="text" class="form-control" v-model="td.otherEmployeeName" id="cpar-no" aria-describedby="code" disabled>
                </div>
                <div class="form-group col-6">
                  <label>Other Employee Number</label>
                  <input type="text" class="form-control" v-model="td.otherEmployeeNumber" id="cpar-no" aria-describedby="code" disabled>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label for="department">Department</label>
                  <input type="text" class="form-control" v-model="td.department" id="department" aria-describedby="code" disabled>
                </div>
                <div class="form-group col-6">
                  <label for="area-observe">Area Observe</label>
                  <input type="text" class="form-control" v-model="td.areaObserve" id="area-observe" aria-describedby="code" disabled>
                  <!-- <app-dropdown :id="'assignedToName'" :keyName="'assignedTo'" :model="td.assignedTo" :lists="areaList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange" ></app-dropdown> -->
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="pic">Detail of Problem</label>
                  <textarea class="form-control" rows="4" v-model="td.problemDetail" id="pic" aria-describedby="code" disabled></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="pic">Remark</label>
                  <textarea class="form-control" rows="6" v-model="td.remark" id="pic" aria-describedby="code" disabled></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-8">
                  <label for="pic">Assign To</label>
                  <input type="text" class="form-control" v-model="td.assignedToName" id="area-observe" aria-describedby="code" disabled>
                  <!-- <app-dropdown :id="'assignedToName'" :keyName="'assignedTo'" :model="td.assignedTo" :lists="areaList" :title="'name'" :value="'id'" v-on:selectedChanged="selectChange" disabled></app-dropdown> -->
                </div>
                <div class="form-group col-4">
                  <label for="pic">Date Time First Assigned</label>
                  <input type="text" class="form-control" v-model="td.assignedToDateTime" id="assigned-to-datetime" aria-describedby="code" disabled>
                </div>
              </div>
              <div v-if="td.questionStatusCode === 'open' || td.questionStatusCode === 'reassign'">
                <button type="button" class="btn btn-outline-primary" style="margin-right: 20px;" @click="updateStatus('approve')">Approve <i class="far fa-thumbs-up"></i></button>
                <div class="row">
                  <div class="form-group col-12">
                    <br />
                    <label for="pic">Reject Reason</label>
                    <textarea class="form-control" rows="6" v-model="td.ownerAreaRemark" id="pic" aria-describedby="code"></textarea>
                  </div>
                </div>
                <button type="button" class="btn btn-outline-danger" style="margin-right: 20px;" @click="updateStatus('reject')">Reject <i class="far fa-thumbs-down"></i></button>

                <div style="float:right;">
                  <!-- <button type="button" class="btn btn-outline-danger" style="margin-left: 20px;" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button> -->
                  <!-- <button type="button" class="btn btn-warning" style="margin-left: 20px;" @click="previewImageDetail">Cetak Gambar dan detail <i class="fas fa-print"></i></button> -->
                  <button type="button" class="btn btn-outline-danger" @click="cancel">Close Page <i class="far fa-window-close"></i></button>
                </div>
              </div>
              <br />
            </div>
        </div>

        <!-- <div v-if="td.questionStatusCode === 'waiting-area-owner'" class="card">
          <div class="header">
            <h2>Corrective and Preventation</h2>
          </div>
          <div class="body">
            <h6>Root Cause</h6>
            <div id="groupRootCause">
              <div class="row">
                <div class="form-group col-12">
                  <label for="root-cause">Machine</label>
                  <textarea class="form-control" placeholder="Please write rootcause from machine perspective" v-model="td.remarkMachineRootCause" id="root-cause" aria-describedby="code"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="root-cause">Man</label>
                  <textarea class="form-control" placeholder="Please write rootcause from man perspective" v-model="td.remarkManRootCause" id="root-cause" aria-describedby="code"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="root-cause">Material</label>
                  <textarea class="form-control" placeholder="Please write rootcause from material perspective" v-model="td.remarkMaterialRootCause" id="root-cause" aria-describedby="code"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="root-cause">Method</label>
                  <textarea class="form-control" placeholder="Please write rootcause from method perspective" v-model="td.remarkMethodRootCause" id="root-cause" aria-describedby="code"></textarea>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label for="root-cause">Environment</label>
                  <textarea class="form-control" placeholder="Please write rootcause from environment perspective" v-model="td.remarkEnvironmentRootCause" id="root-cause" aria-describedby="code"></textarea>
                </div>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="form-group col-12">
                <label for="problem-analysis">Problem Analysis</label>
                <textarea class="form-control" placeholder="Please write why-why analysis for this problem" v-model="td.problemAnalysis" id="root-cause" aria-describedby="code" ></textarea>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6">
                <label for="root-cause">Corrective Action</label>
                <textarea class="form-control" placeholder="Please write how to correct this non conformance" v-model="td.correctiveAction" id="root-cause" aria-describedby="code" ></textarea>
              </div>
              <div class="form-group col-3">
                <label for="cab">Corrective Action By</label>
                <input type="text" class="form-control" placeholder="Please write how to correct this non conformance" v-model="td.correctiveActionBy" id="cab" aria-describedby="code" >
              </div>
              <div class="form-group col-3">
                <label>Corrective Action Date</label>
                <flat-pickr class="form-control" v-model="td.correctiveActionDate" ></flat-pickr>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6">
                <label for="root-cause">Correction Action</label>
                <textarea class="form-control" placeholder="Please write how to prevent this non conformance occurred" v-model="td.preventionAction" id="root-cause" aria-describedby="code" ></textarea>
              </div>
              <div class="form-group col-3">
                <label for="pab">Correction Action By</label>
                <input type="text" class="form-control" placeholder="Please write who will be the PIC for correction action" v-model="td.preventionActionBy" id="pab" aria-describedby="code" >
              </div>
              <div class="form-group col-3">
                <label>Correction Action Date</label>
                <flat-pickr class="form-control" v-model="td.preventionActionDate" ></flat-pickr>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-10">
                <label for="pic">Remark Detail</label>
                <textarea class="form-control" placeholder="Please write detail corrective and correction action (If needed)" v-model="td.remarkDetail" id="pic" aria-describedby="code" ></textarea>
              </div>
              <div class="form-group col-2">
                <label class="fancy-checkbox">
                  <input type="checkbox" name="checkbox" v-model="td.isHappenedBefore" >
                  <span>Happened Before</span>
                </label>
              </div>
            </div>
            <button type="button" class="btn btn-outline-success" style="margin-right: 20px;" @click="save">Save <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" style="margin-right: 20px;" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
          </div>
        </div> -->

        <div v-if="td.questionStatusCode === 'waiting-area-owner' || td.questionStatusCode === 'waiting-qbo-admin'" class="card">
          <div class="header">
            <h2>Corrective and Correction Action</h2>
          </div>
          <div class="body">
            <app-datatable v-if="td.questionStatusCode === 'waiting-area-owner'" :type="'input'" :newData="newDetail" :elements="dtElements" :collections="td.correctiveCorrectionAction"></app-datatable>
            <app-datatable v-if="td.questionStatusCode === 'waiting-qbo-admin'" :type="'view'" :newData="newDetail" :elements="dtElements" :collections="td.correctiveCorrectionAction"></app-datatable>
            <br />
            <div class="row">
              <div class="form-group col-12">
                <label for="pic">Remark from QBO Admin</label>
                <textarea class="form-control" rows="6" v-model="td.qboAdminRemark" id="pic" aria-describedby="code" disabled></textarea>
              </div>
            </div>
            <button type="button" v-if="td.questionStatusCode === 'waiting-area-owner'" class="btn btn-outline-success" style="margin-right: 20px;" @click="save">Update Corrective & Correction Data <i class="far fa-save"></i></button>
            <button type="button" class="btn btn-outline-danger" style="margin-right: 20px;" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
          </div>
        </div>
        
      </div>

      

      <div class="col-lg-3 col-md-4 col-sm-12 file_manager">
        <div class="card">
          <div class="file">
            <a :href="td.evidence">
              <div class="icon">
                <i class="fa fa-file text-info"></i>
              </div>
              <div class="file-name">
                <p class="m-b-5 text-muted">Evidence</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import moment from 'moment'
import { taskDetail, correctiveCorrectionAction } from '../../models/task'
import AppDropdown from '../../components/AppDropdown.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import download from 'js-file-download';

export default {
  components: {
    AppDropdown, AppDatatable
  },
  data() {
    return {
      td: {
        ...taskDetail, 
        correctiveCorrectionAction: []
      },
      newDetail: correctiveCorrectionAction,
      dtElements: [
        // {
        //   title: 'Action No.',
        //   column: 'actionNo',
        //   type: 'text',
        //   width: 4,
        //   disable: true
        // },
        {
          title: 'Root Cause Type',
          column: 'rootCauseType',
          type: 'dropdown',
          width: 2,
          lists: [
              {
                  title: 'Machine',
                  value: 'Machine'
              },
              {
                  title: 'Man',
                  value: 'Man'
              },
              {
                  title: 'Material',
                  value: 'Material'
              },
              {
                  title: 'Method',
                  value: 'Method'
              },
              {
                  title: 'Environment',
                  value: 'Environment'
              }
          ]
        },
        // {
        //   title: 'Root Cause Remark',
        //   column: 'rootCauseRemark',
        //   type: 'text',
        //   width: 6,
        // },
        {
          title: 'Action Type',
          column: 'actionType',
          type: 'dropdown',
          width: 2,
          lists: [
              {
                  title: 'Corrective',
                  value: 'Corrective'
              },
              {
                  title: 'Preventive',
                  value: 'Preventive'
              },
          ]
        },
        // {
        //   title: 'Action Remark',
        //   column: 'actionRemark',
        //   type: 'text',
        //   width: 6,
        // },
        // {
        //   title: 'PIC Name',
        //   column: 'picId',
        //   type: 'lookup',
        //   width: 6,
        //   lookup: {
        //       id: 'memberCorrective',
        //       title: 'Member Data',
        //       type: 'table',
        //       apiUrl: 'member-management/lookup',
        //       filter: ['firstName', 'lastName', 'email'],
        //       fields: [
        //           {
        //               placeholder: 'Responder Name',
        //               width: 5,
        //               column: 'picName'
        //           }
        //       ],
        //       dtElements: [
        //           {
        //               title: 'First Name',
        //               column: 'firstName'
        //           },
        //           {
        //               title: 'Last Name',
        //               column: 'lastName'
        //           },
        //           {
        //               title: 'Email',
        //               column: 'email'
        //           },
        //       ],
        //       affectedField: [
        //           {
        //               from: 'id',
        //               to: 'picId'
        //           },
        //           {
        //               from: 'firstName',
        //               to: 'picName'
        //           },
        //           {
        //               from: 'email',
        //               to: 'picEmail'
        //           },
        //       ]
        //   },
        //   disable: true,
        // },
        // {
        //   title: 'PIC Email',
        //   column: 'picEmail',
        //   type: 'text',
        //   width: 4,
        //   disable: true,
        // },
        {
          title: 'Target Date',
          column: 'targetDate',
          type: 'date',
          width: 1,
          disable: true,
        },
        {
          title: 'Remark',
          column: 'workDescription',
          type: 'text',
          width: 6,
        },
        {
          title: 'Evidence',
          column: 'evidence',
          type: 'upload',
          width: 2,
        },
      ],
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const taskApi = api('task-list-area')
      // console.log(this.$route.query.id)
      this.td = await taskApi.getWithParams(this.$route.query.id)
      // console.log(this.td)
      // console.log(this.td.assignedToDateTime);
      // console.log(moment(this.td.assignedToDateTime).format('YYYY-MM-DD HH:mm:ss'))
    }
  },
  methods: {
    async save() {
      const taskApi = api('task-list-area')
      if(this.$route.query.id !== undefined) {
        await taskApi.update(this.td, this.$route.query.id)
      }
      this.$router.go(0)
    },
    // async approve() {
    //   if(this.$route.query.id !== undefined) {
    //     const taskApi = api('area-owner-approve')
    //     const updateResult = await taskApi.updateWithResponse(this.td, this.$route.query.id)

    //     console.log(updateResult)

    //     if(updateResult !== []) {
    //       if (updateResult.status === 200 || updateResult.status === 201) {
    //         console.log('refresh this page to get latest data')
    //         this.$router.go(0)
    //       }
    //     }
    //   }
    //   // this.$router.go(-1)
    // },
    async updateStatus(status) {
      console.log(status);
      if(status === 'approve' || status === 'reject') {
        const actionApi = api(`area-owner-${status}`)
        const updateResult = await actionApi.updateWithResponse(this.td, this.$route.query.id)

        console.log(updateResult);
      
        if(updateResult !== []) {
          if (updateResult.status === 200 || updateResult.status === 201) {
            if(status === 'approve') {
              console.log('refresh this page to get latest data')
              this.$router.go(0)
            } else {
              console.log('go back to master data')
              this.$router.push({ name: 'areaOwner' })
            }
          }
        }
      }
    },
    cancel() {
      this.$router.push({ name: 'areaOwner' })
    },
    async print() {
      const taskApi = api('report-cpar-partial')
      const query = { 
        params: {
          searchKey: this.td.id,
        }
      }
      const excelFile = await taskApi.getFileWithQuery(query)
      download(excelFile, 'cpar-partial.xlsx')
    },
    selectChange(data) {
      const currentData = this.td
      this.td = {
        ...currentData,
        ...data
      }
    }
  }
}
</script>